// extracted by mini-css-extract-plugin
module.exports = {"section":"recently-viewed-products_section__BNXRm"};